import { backendFetch } from "@/lib/backend";
import type { BillingState, BillingPlan, Promo } from "./types";

export type PlansResponse = {
  plans: BillingPlan[];
  promos: Promo[];
};

export type ValidatePromoInput = {
  code: string;
  planKey?: string;
};

export type ValidatePromoResponse = {
  valid: boolean;
  plan?: BillingPlan;
  promo?: Promo;
  message: string;
};

export type SelectPlanInput = {
  planKey: string;
  promoCode?: string;
};

export type SelectPlanResponse = {
  billing?: {
    planKey: string;
    status: string;
    promoCode?: string;
  };
  plan?: BillingPlan;
};

export type CheckoutInput = {
  planKey: string;
  promoCode?: string;
};

export type CheckoutResponse = {
  url?: string;
};

export type PortalResponse = {
  url?: string;
};

export async function getBilling(): Promise<BillingState> {
  return (await backendFetch("/billing")) as BillingState;
}

export async function getPlans(): Promise<PlansResponse> {
  return (await backendFetch("/billing/plans")) as PlansResponse;
}

export async function validatePromo(data: ValidatePromoInput): Promise<ValidatePromoResponse> {
  return (await backendFetch("/billing/promo/validate", {
    method: "POST",
    body: JSON.stringify(data),
  })) as ValidatePromoResponse;
}

export async function selectPlan(data: SelectPlanInput): Promise<SelectPlanResponse> {
  return (await backendFetch("/billing/select-plan", {
    method: "POST",
    body: JSON.stringify(data),
  })) as SelectPlanResponse;
}

export async function createCheckout(data: CheckoutInput): Promise<CheckoutResponse> {
  return (await backendFetch("/billing/checkout", {
    method: "POST",
    body: JSON.stringify(data),
  })) as CheckoutResponse;
}

export async function createPortal(): Promise<PortalResponse> {
  return (await backendFetch("/billing/portal", { method: "POST" })) as PortalResponse;
}
